"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utility class for random Id generation.
 */
class IdGenerator {
    /**
     * Generate a RFC4122 v4 compliant UUID.
     *
     * @returns The newly generated UUID.
     */
    uuidV4() {
        /* Tslint:disable:no-bitwise */
        let d = Date.now(); // Start with now as a seed
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, xy => {
            const r = (d + Math.random() * 16) % 16 | 0; // Generate a new random number
            const c = xy === 'x' ? r : (r & 0x3) | 0x8; // Make sure it's  RFC4122 version 4 compliant
            d = Math.floor(d / 16); // Update the seed
            return c.toString(16); // Return the hex digit
        });
        /* Tslint:enable:no-bitwise */
    }
}
exports.default = IdGenerator;
//# sourceMappingURL=IdGenerator.js.map